@if(mode==="edit"){
@if(source !== 'enrollment'){
<div class="ppl-mt8">
  @for(header of extractValues('header'); track $index){
  <h2 tabindex="-1" pplAutoFocusHeader>{{header}}</h2>
  }
  @for(text of extractValues('text'); track $index){
  <p class="ppl-description">{{text}}</p>
  }
</div>
}
<div [ngClass]="{'ppl-mt24': source !== 'enrollment'}">
  <nz-card nz-col [nzSpan]="source !== 'enrollment' ? 20 : 24" class="ppl-p24 ppl-step-main" [nzBordered]="false">
    <form nz-form [formGroup]="contactForm" class="ppl-p0">
      <nz-row [nzGutter]="16" class="ppl-new-form-control">
        @if(isAttrAvailable('preferredMethod')){
        <nz-col [nzSpan]="12">
          <nz-form-label [nzSpan]="24" nzFor="preferredMethod"
            [ngStyle]="{ 'margin-bottom':'0' }">{{getAttributes('preferredMethod').label}}
            @if(getAttributes('preferredMethod').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-radio-group [ngClass]="{'error': validationErrors['preferredMethod'] }" nz-tooltip
              nzTooltipTitle="{{getAttributes('preferredMethod').tooltip}}" nzTooltipPlacement="topRight"
              id="preferredMethod" formControlName="preferredMethod" class="ppl-radio-group"
              [attr.aria-invalid]="validationErrors['preferredMethod'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['preferredMethod'] ? 'preferredMethod-error' : null">
              <label nz-radio-button [nzValue]="getNzValue('Email')">Email</label>
              <label nz-radio-button [nzValue]="getNzValue('Mobile')">Mobile</label>
            </nz-radio-group>
            @if (validationErrors['preferredMethod']) {
            <span class="pl-1 error-message" id="preferredMethod-error" role="alert">{{validationErrors['preferredMethod']}}</span>
            }
          </nz-form-control>
        </nz-col>
        }
      </nz-row>
      <nz-row class="ppl-new-form-control" [nzGutter]="16">
        @if(isAttrAvailable('email') || isAttrAvailable('mobile') || isAttrAvailable('altPhone')){
          <nz-divider class="divider"></nz-divider>
          <nz-col [nzSpan]="8" [nzSm]="24" [nzXs]="24">
            <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
              <nz-form-label [nzSpan]="24" nzFor="email" style="margin-bottom: 8px !important;"
              class="ppl-form-label">
              Please provide a value for at least one of the following contact methods:
                <span [attr.aria-label]="'Required'">*</span>
              </nz-form-label>
              @if(isAttrAvailable('email')){
              <nz-form-control [nzSpan]="24" class="ppl-mr16">
                <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('email').tooltip}}"
                  nzTooltipPlacement="topRight" formControlName="email" id="email"
                  [ngClass]="{'error': validationErrors['email'] }"
                  placeholder="{{getAttributes('email').placeholder}}" [readonly]="formReadonly"
                  [attr.aria-invalid]="validationErrors['email'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['email'] ? 'email-error' : null" />
                @if (validationErrors['email']) {
                <span class="pl-1 error-message" id="email-error" role="alert">{{validationErrors['email']}}</span>
                }
              </nz-form-control>
            }
              @if(isAttrAvailable('mobile')){
              <nz-form-control [nzSpan]="24" class="ppl-mr16">
                <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('mobile').tooltip}}"
                  nzTooltipPlacement="topRight" formControlName="mobile" id="mobile"
                  [ngClass]="{'error': validationErrors['mobile'] }"
                  placeholder="{{getAttributes('mobile').placeholder}}" [readonly]="formReadonly"
                  [attr.aria-invalid]="validationErrors['mobile'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['mobile'] ? 'mobile-error' : null" />
                @if (validationErrors['mobile']) {
                <span class="pl-1 error-message" id="mobile-error" role="alert">{{validationErrors['mobile']}}</span>
                }
              </nz-form-control>
            }
            @if(isAttrAvailable('altPhone')){
                  <nz-form-control [nzSpan]="24">
                    <input nz-tooltip nzTooltipTitle="{{getAttributes('altPhone').tooltip}}" nzTooltipPlacement="topRight"
                      nz-input formControlName="altPhone" [ngClass]="{'error': validationErrors['altPhone'] }" id="altPhone"
                      placeholder="{{getAttributes('altPhone').placeholder}}" [readonly]="formReadonly"
                      [attr.aria-invalid]="validationErrors['altPhone'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['altPhone'] ? 'altPhone-error' : null" />
                    @if (validationErrors['altPhone']) {
                    <span class="pl-1 error-message" id="altPhone-error" role="alert">{{validationErrors['altPhone']}}</span>
                    }
                  </nz-form-control>
              }
            </nz-form-item>
          </nz-col>
          <nz-divider class="divider"></nz-divider>
          }
      </nz-row>
      @if(isAttrAvailable('permanentAddress')){
      <!-- <nz-divider class="divider" style="margin-top: 16px;"></nz-divider> -->
      <nz-form-item class="ppl-form-item">
        <!-- <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="permanentAddress"
              class="ppl-form-label">{{getAttributes('permanentAddress').label}}
              @if(getAttributes('permanentAddress').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }
            </nz-form-label> -->
        <div class="address-section">
          <nz-form-control class="ppl-form-control address-control">
            <ppl-enrollment-address [addressForm]="getFormGroup('permanentAddress')"
              [permanentValidationErrors]="permanentValidationErrors" [is_permanent]="isMailing"
              [showPSD]="showPSD" [formReadonly]="formReadonly"></ppl-enrollment-address>
            <!-- <ppl-address [addressForm]="getFormGroup('permanentAddress')" [permanentValidationErrors]="permanentValidationErrors" [is_permanent]="isMailing" [showPSD]="showPSD"></ppl-address> -->
          </nz-form-control>
        </div>
      </nz-form-item>
      <!-- <nz-divider class="divider"></nz-divider> -->
      }
      @if(!contactForm.get('permanentAddress')?.value.mailing){
      @if(isAttrAvailable('mailingAddress')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mailingAddress"
          class="ppl-form-label">{{getAttributes('mailingAddress').label}}
          @if(getAttributes('mailingAddress').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <div class="address-section">
          <nz-form-control class="ppl-form-control address-control">
            <ppl-enrollment-address [addressForm]="getFormGroup('mailingAddress')"
              [mailingValidationErrors]="mailingValidationErrors" [is_permanent]="false"
              [showPSD]="showPSD"></ppl-enrollment-address>
            <!-- <ppl-address [addressForm]="getFormGroup('mailingAddress')" [mailingValidationErrors]="mailingValidationErrors" [is_permanent]="false" [showPSD]="showPSD"></ppl-address> -->
          </nz-form-control>
        </div>
        <!-- <nz-divider class="divider"></nz-divider> -->
      </nz-form-item>
      }
      }
      @if(isAttrAvailable('residentGt18')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="residentGt18"
          class="ppl-form-label">{{getAttributes('residentGt18').label}}
          @if(getAttributes('residentGt18').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('residentGt18')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group [ngClass]="{'error': validationErrors['residentGt18'] }" formControlName="residentGt18"
              class="ppl-radio-group" id="residentGt18"
              [attr.aria-invalid]="validationErrors['residentGt18'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['residentGt18'] ? 'residentGt18-error' : null">
              @for(opt of radioOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
              <label nz-radio-button [nzValue]="'unknown'">Unknown</label>
            </nz-radio-group>
          </div>
          @if (validationErrors['residentGt18']) {
          <span class="pl-1 error-message" id="residentGt18-error" role="alert">{{validationErrors['residentGt18']}}</span>
          }

        </nz-form-control>
      </nz-form-item>
      }
      @if(contactForm.get('residentGt18')?.value === 'Yes'){
      <div nzRow>
        <div nzCol nzOffset="8" nzSpan="16">
          <p>This response may require additional background checks for an employee during the time of enrollment.</p>
        </div>
      </div>
      }
      @if(isAttrAvailable('yearsInState')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="yearsInState"
          class="ppl-form-label">{{getAttributes('yearsInState').label}}
          @if(getAttributes('yearsInState').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('yearsInState').tooltip}}"
            nzTooltipPlacement="topRight" formControlName="yearsInState" id="yearsInState"
            [ngClass]="{'error': validationErrors['yearsInState'] }"
            placeholder="{{getAttributes('yearsInState').placeholder}}" [readonly]="formReadonly"
            [attr.aria-invalid]="validationErrors['yearsInState'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['yearsInState'] ? 'yearsInState-error' : null" />
          @if (validationErrors['yearsInState']) {
          <span class="pl-1 error-message" id="yearsInState-error" role="alert">{{validationErrors['yearsInState']}}</span>
          }
          <div class="notes">
            <p>
              This response may require additional background checks during enrolment.
            </p>
          </div>
        </nz-form-control>
      </nz-form-item>
      }
    </form>
  </nz-card>
</div>
}
@else if(mode==="read"){
@if(isAttrAvailable('preferredMethod')){
<div nz-row>
  <div nz-col nzSpan="11" class="ppl-read-label" style="margin-right:8px">{{ getAttributes('preferredMethod').label }}
  </div>
  <div nz-col nzSpan="12">{{ getLookupValue(communicationType, filledInfo['preferredMethod'])}}</div>
</div>
}
@if(isAttrAvailable('email')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('email').label}} :</div>
  <div nz-col nzSpan="16">{{filledInfo['email']}}</div>
</div>
}
@if(isAttrAvailable('altPhone')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('altPhone').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['altPhone']}}</div>
</div>
}
@if(isAttrAvailable('mobile')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('mobile').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['mobile']}}</div>
</div>
}
@if(isAttrAvailable('permanentAddress')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('permanentAddress').label}} :</div>
</div>
<div>
  <ppl-address [mode]="'read'" [showPSD]="showPSD" [data]="filledInfo['permanentAddress']"></ppl-address>
</div>
}

@if(isAttrAvailable('mailingAddress')){
@if(!contactForm.get('permanentAddress')?.value.mailing){
<div nz-row>
  <div nz-col nzSpan="12" class="ppl-read-label">{{getAttributes('mailingAddress').label}} :</div>
</div>
<div>
  <ppl-address [mode]="'read'" [is_permanent]="false" [showPSD]="showPSD" [data]="filledInfo['mailingAddress']"></ppl-address>
</div>
}
}
@if(isAttrAvailable('residentGt18')){
<div nz-row>
  <div nz-col nzSpan="11" class="ppl-read-label" style="margin-right:8px">{{getAttributes('residentGt18').label}} :
  </div>
  <div nz-col nzSpan="12">{{ filledInfo['residentGt18'] }}</div>
</div>
}
}